import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './styles.css';

const LOCAL_STORAGE_KEY = 'hidePreferencesNotice';

const UserPreferencesNoticeCard = () => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [mounted, setMounted] = useState(false);
  const [isHidden, setIsHidden] = useState(false);

  // Vérifier si l'utilisateur a déjà masqué la notification
  useEffect(() => {
    const hideNotice = localStorage.getItem(LOCAL_STORAGE_KEY) === 'true';
    console.log('UserPreferencesNoticeCard: hideNotice =', hideNotice);
    
    setIsHidden(hideNotice);
    
    if (!hideNotice) {
      // Ajouter un délai pour l'animation
      setTimeout(() => {
        setVisible(true);
      }, 300);
    }
    
    setMounted(true);
  }, []);

  // Rediriger vers les préférences du feed
  const handleViewPreferences = () => {
    navigate('/dashboard/settings?section=feed');
  };

  // Ne plus afficher l'élément
  const handleDismiss = () => {
    setVisible(false);
    setIsHidden(true);
    
    // Ajouter un délai avant de stocker dans le localStorage pour l'animation de sortie
    setTimeout(() => {
      localStorage.setItem(LOCAL_STORAGE_KEY, 'true');
    }, 300);
  };

  // Si le composant n'est pas encore monté, ne rien afficher
  if (!mounted) {
    return null;
  }

  // Si l'utilisateur a déjà masqué la notification, ne rien afficher
  if (isHidden) {
    return null;
  }

  return (
    <div className={`preferences-notice-card ${visible ? 'visible' : ''}`}>
      <div className="preferences-notice-content">
        <p className="preferences-notice-message">{t('preferencesNotice.message')}</p>
        <div className="preferences-notice-actions">
          <button 
            className="preferences-notice-primary-button" 
            onClick={handleViewPreferences}
          >
            {t('preferencesNotice.viewPreferences')}
          </button>
          <button 
            className="preferences-notice-secondary-button" 
            onClick={handleDismiss}
          >
            {t('preferencesNotice.dismiss')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserPreferencesNoticeCard; 